<script lang="ts">
    import { onMount } from "svelte";   
    import Employee from "../../../Models/Employee";
    import Chart from "../../Chart/Chart.svelte";

    export let employeeID: string;

    let productsChartLabels = [];
    let productsChartValues = [];
    let purchasesSummary;

    onMount(async () => {
        const res = await Employee.getPurchasesSummary(employeeID);
        purchasesSummary = res;
        if (purchasesSummary) {
            for (const [label, value] of Object.entries(purchasesSummary.purchasesCount.byProduct)) {
                productsChartLabels.push(label);
                productsChartValues.push(value);
            }
        }
    })
</script>

{#if purchasesSummary}
    <Chart labels={productsChartLabels} data={productsChartValues} label="Ilość produktów" />
{/if}

